export default __webpack_public_path__ + "static/media/domain_name.e1c00666.csv";